import { React, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Menu from './sub_components/Menu.js'
import Code from './sub_components/Code.js'
import Paragraph from './sub_components/Paragraph.js'
import References from './sub_components/References.js'

import Me from '../images/me_Col.png'
import '../stylesheets/ArticleSS.css'
import captcha from "../images/icons/captcha.png"

import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics } from "firebase/analytics";

import E404 from "./E404.js"
import LoadingSpinner from './sub_components/LoadingSpinner.js'

function Article() {

  const firebaseConfig = {
    apiKey: "AIzaSyAHgS8Q5mUbdXnLSBlKDeRgsDjlXVl3Snk",
    authDomain: "blog-adam-kaminski.firebaseapp.com",
    projectId: "blog-adam-kaminski",
    storageBucket: "blog-adam-kaminski.appspot.com",
    messagingSenderId: "479060367833",
    appId: "1:479060367833:web:c92d07653a77b78181a1c8",
    measurementId: "G-GNRTCPM9C6",
    databaseURL: "https://blog-adam-kaminski-default-rtdb.europe-west1.firebasedatabase.app"
  };
  const app = initializeApp(firebaseConfig);
  //eslint-disable-next-line
  const analytics = getAnalytics(app);

  // eslint-disable-next-line
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LcHvl8hAAAAAKCvepBnWlKE_5fqB2jtUOtczm-O")
  });

  //getting the routed location of the user and using this to route
  let id = window.location.toString().substring(window.location.toString().lastIndexOf('/') + 1);

  // Hold article data
  const [article, setArticle] = useState({});

  useEffect(() => {
    //fetching specific article
    const db = getDatabase(app);
    const articleFetch = ref(db, `articles/${id}`);//Fetching specific article
    onValue(articleFetch, (snapshot) => {
      const data = snapshot.val();
      setArticle(data);
    });

    // eslint-disable-next-line
  }, [])
  //for invalid articles that dont exist
  if (article === null) {
    return (
      <E404></E404>
    )
  }

  return (
    <div id='article_container'>

      {(article.Title === undefined) ? <LoadingSpinner></LoadingSpinner> : <div>
        <Helmet>
          <title>{article.Title}</title>
          <meta name="description" content={`A software article about ${article.Topic.join(' ')}`} />
          <meta name="keywords" content={article.Topic.join(' ')} data-react-helmet="true" />
          <meta name="author" content="Adam Kaminski" data-react-helmet="true" />
          <meta name="title" content={article.Title} data-react-helmet="true" />
        </Helmet>
        <Menu></Menu>
        <section id='banner' style={{ backgroundImage: `url(${article.Img})` }} alt={`Tech banner - ${article.Title}`}></section>
        <article id='article_content'>
          <div id='title_text'>
            <header>
              <img src={Me} alt="AK_icon" id='pfp'></img>
              <div>
                <h1>
                  {article.Title}
                </h1>
                <section>
                  <h4>{article.Date}&nbsp;</h4>
                  <h4>| {article.Author}</h4>
                </section>
              </div>
            </header>
            <hr></hr>
            <article id='content'>
              {/* Map through the text array and use handlebars */}
              {article.Text.map((paragraph, index) => {
                if (paragraph.code === undefined) {
                  return (
                    <article key={index} id='article_text'>
                      <Paragraph text={paragraph.text}></Paragraph>
                    </article>
                  )
                }
                return (
                  <article key={index} id='article_text'>
                    <Paragraph text={paragraph.text}></Paragraph>
                    <Code text={paragraph.code} language={paragraph.lang}></Code>
                  </article>
                )
              })}
              <References sources={article.References}></References>
            </article>
          </div>
        </article>
        <img src={captcha} alt="captcha" id="captcha"></img></div>}
    </div>
  )
}

export default Article